/* eslint-disable */
import { appService } from "../../_services";

const siteInfo = {
    colorInfo: {
        "iconColor": "#fe9e30",
        "sectionBackgroundColor": "#efefef",
        "sectionSelectedColor": "white",
        "sectionSelectedBackgroundColor": "##095686",
        "therapeutSelectColor": null,
        "therapeutSelectBackgroundColor": "#fe9e30",
        "therapeutUnavailableBackgroundColor" : "#a8a8a8",
        "timeSlotBorderColor": "##35FE30",
        "submitButtonColor": null,
        "submitButtonBackgroundColor": "#fe9e30"
    }
}

const state = { status: { requesting: true }, siteInfo }

const actions = {
    getSiteInfo({ dispatch, commit }) {
        commit("siteInfoRequest");

        appService.getSiteInfo().then(
            (info) => {
                commit("siteInfoRequestSuccess", info);
            },
            (error) => {
                commit("siteInfoRequestFailure", error);
                dispatch("alert/error", error, { root: true });
            }
        );
    }
};

const mutations = {
    siteInfoRequest(state) {
        state.status = { requesting: true };
        state.siteInfo = null;
    },
    siteInfoRequestSuccess(state, info) {
        state.status = { requestSuccess: true };
        state.siteInfo = { ...info };
    },
    siteInfoRequestFailure(state) {
        state.status = { requestSuccess: false };
        state.siteInfo = null;
    },
};

export const app = {
    namespaced: true,
    state,
    actions,
    mutations,
};

